<template>
  <growth-contact-button
    v-track="'course_download_program_clicked'"
    :block="block"
    :color="color"
    :confirmation-toast="false"
    data-cy-download-program-cta
    origin="course"
    :origin_page_action="origin_page_action"
    :origin_page_id="course.slug"
    :redirect="redirect"
    size="lg"
    skip-form-if-known-user
    :variant="variant"
    @skipped="download"
  >
    {{ $t("course.page.program_download_cta") }}
  </growth-contact-button>
</template>

<script lang="ts" setup>
import type { ButtonProps } from "@pollen/ui-library";

import type { CoursePageView } from "~/business-areas/course/course.model";
import type { CourseSessionView } from "~/business-areas/course-session/course-session.model";

const properties = defineProps<
  ButtonProps & {
    course: CoursePageView;
    session?: CourseSessionView;
  }
>();

const { download } = useCoursePageProgramDownload(properties.course);

const route = useRoute();

const redirect = computed(() => `${route.path}?download_program=true`);

const origin_page_action = computed(() =>
  properties.course.has_program
    ? "download_program_cta"
    : "follow_up_program_cta",
);
</script>
